// extracted by mini-css-extract-plugin
export default {"formSwitch":"PollQuestion_formSwitch__OpRJT"};